module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('markdown-header'), _c('markdown2html'), _c('markdown-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.markdownStr),
      expression: "markdownStr"
    }],
    ref: "markdownInput",
    domProps: {
      "value": (_vm.markdownStr)
    },
    on: {
      "flod": _vm.textareaFold,
      "input": function($event) {
        _vm.markdownStr = $event
      }
    }
  }), _c('new-markdown', {
    attrs: {
      "type": "create"
    }
  }), _c('new-markdown', {
    attrs: {
      "type": "revise"
    }
  }), _c('rename', {
    attrs: {
      "renameFileList": _vm.renameFileList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-782588de"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 280
// module chunks = 1